<template >
  <div>
    <template>
      <v-container class="grey lighten-5">
        <!-- <v-overlay :value="$store.state.isloading">
          <v-progress-circular indeterminate size="64">
            <span v-if="$store.state.isloading" style="font-size:15px;">{{ titulo }} abrirá em uma nova janela...Por favor
              aguarde</span>
          </v-progress-circular>
        </v-overlay> -->
        <v-row no-gutters>
          <v-col>
            <div class="text-center">
              <v-container fluid>
                <v-row>
                  <v-col md="12">
                    <input style="display:none" ref="input" type="file" name="image" accept="image/*" @change="setImage" />
                    <img :src="foto" style="width:140px;height:140px;border-radius:10px;" @load="progresso2">
           <v-btn @click="showFileChooser()" style="margin-left:10px;margin-top:-50px;"   small fab dark color="primary" v-if="estudante_dados.length">
                    <v-icon dark small>add_a_photo</v-icon>
                </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-col>
        </v-row>
<!-- ********************************************************************************************** -->
<template>
            <v-row justify="center">
              <v-dialog
                v-model="dialogoUpload"
                persistent
                max-width="450px"
              >
                <v-card>
                  <v-card-title style="background-color:#006699;">
                    <span class="text-h5" style="color:white;">Carregar foto </span><br>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="2" md="2" ></v-col>
                        <v-col cols="12" sm="10" md="10" >
                          <v-col md="8">
                          <div>
                            <div class="content">
                              <section class="cropper-area">
                                <div class="img-cropper">
                                  <vue-cropper v-if="imgSrc !== ''"
                                    ref="cropper"
                                    :aspect-ratio="20 / 20"
                                    :src='imgSrc'
                                    preview=".preview"
                                  />
                                </div>
                              </section>
                              <!-- <v-btn v-if="imgSrc !== ''" small @click.prevent="showFileChooser" fab dark color="blue"><v-icon small dark >add_a_photo</v-icon></v-btn> -->
                            <v-btn v-if="imgSrc !== ''" small @click.prevent="cropImage" fab dark color="#808080"><v-icon small dark >crop</v-icon></v-btn>

                        </div>
                      </div>
                          </v-col>
              </v-col>
                </v-row>
                      <hr>
                      <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red" text @click="reset()">Cancelar</v-btn>
                    </v-card-actions>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-row>
          </template>
<!-- ******************************************************************************************************* -->
 
        <!--==== CONTAINER DO COMPONENTE FILHO DE PESQUISA ====-->
        <div class="containerPesquisarComponete">
          <pesquisar @estudanteEscolhido="getHistoricoAluno" :redColorActive="isEstudanteEmpty"></pesquisar>
        </div>
        <!--==== FIM CONTAINER DO COMPONENTE FILHO DE PESQUISA ====-->

        <div class="operacoes_container">
          <button  @click="selecionarMenu(4)" class="operacoes_button" :class="{ botao_selected: menuSelected == 4 }" v-if="!isintegrado"> Cadastrar Estudante </button>
          <button @click="selecionarMenu(1)" class="operacoes_button" :class="{ botao_selected: menuSelected == 1 }"> Dados do estudante</button>
          <button @click="selecionarMenu(2)" class="operacoes_button" :class="{ botao_selected: menuSelected == 2 }"> Mudança de turma </button>
          <button @click="selecionarMenu(3)" class="operacoes_button" :class="{ botao_selected: menuSelected == 3 }"> Mudança de classe </button>
        </div>
        <v-row>
          <v-col md="2">
            <v-card class="mx-auto"><cadastrarEstudante @fecharComponente="fecharTelaComponente" v-if="menuSelected === 4"></cadastrarEstudante></v-card>
          </v-col>
        </v-row>
        <v-card class="mx-auto" v-if="estudante_dados.length">
          <v-row>
            
            <v-col md="3">
              <impressaoEstudante :estudante="estudante_dados[0]" :estudante_dados="estudante_dados" />
            </v-col>
            <v-col md="9" class="rigth_container_components">
              <tableDadosAcademicos :estudanteDados="estudante_dados" v-if="menuSelected == 1"></tableDadosAcademicos>
              <mudarTurmaEst :estudante="estudante_dados[0]" @fecharComponente="fecharTelaComponente" v-if="menuSelected == 2"></mudarTurmaEst>
              <mudarClasseEst :estudante="estudante_dados[0]" @fecharComponente="fecharTelaComponente" v-if="menuSelected == 3"></mudarClasseEst>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </template>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
const ls = require('local-storage')
import pesquisar from './componentes/estudante/pesquisar.vue'
import informacoesPessoais from './componentes/estudante/dadosPessoais.vue'
import tableDadosAcademicos from './componentes/estudante/tabelaDadosAcademicos.vue'
import mudarTurmaEst from './componentes/estudante/mudarTurma.vue'
import mudarClasseEst from './componentes/estudante/mudancaClasse.vue'
import cadastrarEstudante from './componentes/estudante/cadastrar.vue'
import impressaoEstudante from './componentes/estudante/impressao.vue'
export default {
  components: {
    pesquisar,
    informacoesPessoais,
    tableDadosAcademicos,
    mudarTurmaEst,
    mudarClasseEst,
    cadastrarEstudante,
    impressaoEstudante,
    VueCropper
  },
  data: () => ({
    menuSelected: undefined,
    estudantePesquisa: null,
    isEstudanteEmpty: false,
    isLoading_: false,
    search: null,
    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    idMatricula: null,
    matricula_actual: '',
    msg_pesquisa: true,
    pesquisa: '',
    estudante: true,
    dialogTrancarMatricula: false,
    dialog: false,
    dialogConfrmar: false,
    dialogoUpload: false,
    data: null,
    imgSrc: '',
    cropImg: '',
    progresso: false,
    progresso2: false,
    Pessoas: [],
    tab: null,
    items: ['Dados académicos', 'Outras informações'],
    text: 'Informação indisponível de momento.',
    titulo: '',
    progress: false,
    componente: [],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Curso - Inscrito ', value: 'descricao_curso' },
      { text: 'Classes( Feitas )', value: 'classe' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aprov.', value: 'resultado' },
      { text: 'Estado', value: 'estado' }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ],
    overlay: false,
    foto: '',
    instituicao_id: ls.get('i_id'),
    cor: '',
    msg: '',
    objEstudante: null,
    editedIndex: -1,
    alunos: ls.get('estudantes'),
    editedItem: {
      anoLectivo: '',
      bi: '',
      curso: '',
      data_: '',
      foto: '',
      idMatricula: '',
      instituicao: '',
      nome: '',
      pkPessoa: 0,
      resultado: '',
      turma: ''
    },
    defaultItem: {
      anoLectivo: '',
      bi: '',
      curso: '',
      data_: '',
      foto: '',
      idMatricula: '',
      instituicao: '',
      nome: '',
      pkPessoa: 0,
      resultado: '',
      turma: ''
    }

  }),

  computed: {
    isintegrado(){
      return ls.get('isintegrado')
    },
    isFinalista() {
      // @ts-ignore
      return this.estudante_dados.filter(e => parseInt(e.idAno_Academico) === 4 && e.resultado === 'Transita').length
    },
    idclasse() {
      return this.$store.state.idclasse
    },
    textMessage() {
      return this.$store.state.textMessage
    },
    classMessage() {
      return this.$store.state.classMessage
    },
    hasMessage() {
      return this.$store.state.hasMessage
    },
    role() {
      return ls.get('role')
    },
    anolectivo() {
      return ls.get('anolectivo')
    }
  },
  watch: {
    estudantes() {
      this.$store.state.isloading = false
    },
    foto() {
      return ls.get('urlReport') + 'readphoto/' + '' + this.$store.state.objaluno.foto
    },
    search(val) {
      if (val && val.length > 0) {
        if (!this.alunos.filter(t => t.nome.includes(val)).length) {
          this.alunos = []
        }
        return this.pesquisaEstudante(val)
      }
    }
  },
  created() {
    this.foto = ls.get('urlReport') + 'readfile/user.png'
    this.controloestudanteinstituicao()
    this.$store.state.showDialogGuia = { cartao: false, carta: false, declaracao: false, declaracao_nota: false, ficha: false, guia: false, historico: false, listaestudante: false }
    if (this.$store.state.objaluno) {
      this.editedItem = this.$store.state.objaluno
      this.getHistoricoAluno()
      this.instit = ls.get('instituicaodescricao')
      if (window.location.host.includes('localhost')) {
        this.iskilamba = true
      } else if (window.location.host.includes('eftsk')) {
        this.iskilamba = true
      } else if (window.location.host.includes('eftsl')) {
        this.iskilamba = false
      }
    }
  },
  methods: {
    loadStudents() {
      this.pesquisaEstudante('a')
    },
    
    async showTrancarMatricula() {
      if (this.estudante_dados[0].status_2 == 2) {
        Swal.fire('Informação', 'Estudante já com matrícula trancada', 'info')
      } else
        this.dialogTrancarMatricula = true
    },

    async confirmarMatricula() {
      this.dialogConfrmar = true
    },

    async saveTrancarMatricula() {
      try {
        let params =
        {
          item: this.estudante_dados[0]
        }
        let result = await axios.post('/trancarMatricula', params).then((res) => res.data)
        if (result.affectedRows >= 1) {
          Swal.fire('Informação', 'Matrícula Trancada com sucesso', 'success')
          this.getHistoricoAluno()
          this.dialogTrancarMatricula = false
          this.dialogConfrmar = false
        }
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
      }
    },

    async pesquisaEstudante(searchInDb) {
      try {
        if (!searchInDb) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + searchInDb + '"}'
        }
        this.isLoading_ = true
        this.alunos = await axios
          .get('/estudanteFindAll-geral/' + payload)
          .then(res => res.data)
        this.isLoading_ = false
      } catch (error) {
        this.isLoading_ = false
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar estudantes'
        })
      }
    },
    async comporFoto (aluno) {
      try {
        this.foto = `${ls.get('urlReport')}readphotoBySigla/` + aluno.foto + '/' + ls.get('sigla')
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar a foto' })
      }
    },
    async getHistoricoAluno(estudante) {
      this.estudantePesquisa = estudante;
      if (estudante) {
        try {
          this.progresso = true
          this.estudante_dados = await axios.get('/PesquisaGlobal/' + estudante.idMatricula).then(res => res.data)
          // this.$store.state.objaluno = this.editedItem
          this.progresso = false
          if (!this.estudante_dados.length) {
            this.msg_pesquisa = false
          } else {
            this.$store.state.objaluno = estudante
            this.msg_pesquisa = true
            this.objEstudante = this.estudante_dados[0]
            this.comporFoto(this.estudante_dados[0])
            this.selecionarMenu(1)
            this.isEstudanteEmpty = false;
          }
        } catch (error) {
          this.progresso = false
          Swal.fire({
            icon: 'error',
            title: '',
            text: 'Ocorreu um erro ao carregar o relatório'
          })
        }
      } else {
        this.progresso = false
      }
    },
    setImage (e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        Swal.fire({ icon: 'warning', title: '', text: 'Por favor selecione uma imagem' })
      } else {
        if (typeof FileReader === 'function') {
          this.sufixOriginalname = file.name
          this.dialogoUpload = true
          const reader = new FileReader()
          reader.onload = (event) => {
            this.imgSrc = event.target.result
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          Swal.fire({ icon: 'warning', title: '', text: 'Ficheiro não suportado' })
        }
      }
    },
    cropImage () {
      try {
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
        this.savephoto()
      } catch (error) {
        this.dialogoUpload = false
        this.imgSrc = ''
        this.progresso2 = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao cortar a foto' })
      }
    },

    flipX () {
      const dom = this.$refs.flipX
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleX(scale)
      dom.setAttribute('data-scale', scale)
    },
    flipY () {
      const dom = this.$refs.flipY
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleY(scale)
      dom.setAttribute('data-scale', scale)
    },
    getCropBoxData () {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4)
    },
    getData () {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4)
    },
    move (offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY)
    },
    reset () {
      try {
        this.$refs.cropper.reset()
        this.cropImg = null
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro' })
      } finally {
        this.dialogoUpload = false
        this.imgSrc = ''
        this.progresso2 = false
      }
    },
    rotate (deg) {
      this.$refs.cropper.rotate(deg)
    },
    setCropBoxData () {
      if (!this.data) return
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data))
    },
    setData () {
      if (!this.data) return
      this.$refs.cropper.setData(JSON.parse(this.data))
    },
    zoom (percent) {
      this.$refs.cropper.relativeZoom(percent)
    },
    showFileChooser () {
      this.$refs.input.click()
    },
    async savephoto () {
      try {
        this.$store.state.isloading = true
        this.progresso2 = true
        this.titulo = 'O carregamento de foto'
        let fileName = this.estudante_dados[0].idMatricula + '.png'
        let params = { fileName: fileName, ficheiro: this.cropImg, pkPessoa: this.estudante_dados[0].pkPessoa, sigla: ls.get('sigla') }
        let result = await axios({ method: 'post', url: ls.get('urlReport') + 'uploadImg', data: params }).then(res => res.data)
        if (result && result.affectedRows > 0) {
          this.foto = this.cropImg
          setTimeout(() => {
            this.estudante_dados[0].foto = fileName
            this.$store.state.objaluno.foto = fileName
            this.$store.state.isloading = false
          }, 700)
        }
      } catch (error) {
        this.$store.state.isloading = false
        this.dialogoUpload = false
        this.imgSrc = ''
        this.progresso2 = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao realizar a operação' })
      } finally {
        this.$store.state.isloading = false
        this.dialogoUpload = false
        this.imgSrc = ''
        this.progresso2 = false
      }
    },
    async show_dialogo_transitacao() {
      this.dialog = true
    },   
    
    

    selecionarMenu(opcao) {
      if (opcao === 4) {
        this.menuSelected = opcao;
      } else {
        this.isEstudanteEmpty = this.isValid()
        if (!this.isEstudanteEmpty) {
          this.menuSelected = opcao;
        }
      }
    },

    isValid() {
      if (this.estudante_dados.length) {
        return false;
      } else {
        return true;
      }
    },
    async controloestudanteinstituicao () {
      try {
        this.overlay = true
        this.constrolo_estudantes_instituicao = await axios.post('/Config_instituicao_estudantes', { anolectivo: ls.get('anolectivo') }).then((res) => res.data)
        if (this.constrolo_estudantes_instituicao.length) {
          this.$store.state.config_estudante_instituicao = this.constrolo_estudantes_instituicao.filter(c => parseInt(c.anoacademico) === 1)
        }
        this.InitializeCadastrados(1)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        Swal.fire('Informação', 'Ocorreu um erro no carregamento das estatísticas de cadastramento', 'error')
      }
    },
    async InitializeCadastrados (classe) {
      try {
        this.overlay = true
        this.cadastrados = await axios.post('/estudantes_cadastrados', { classe: classe, anolectivo: ls.get('anolectivo') }).then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação.', 'error')
      }
    },

    AtingiuLimite () {
      let result = ((this.$store.state.config_estudante_instituicao.length) ? parseInt(this.$store.state.config_estudante_instituicao[0].quantidade) : 0) - ((this.cadastrados.length) ? parseInt(this.cadastrados[0].cadastrados) : 0)
      return (result <= 0)
    },
    selecionarMenu (opcao) {
      if (opcao === 4) {
        if (this.AtingiuLimite()) {
          Swal.fire('Informação', ` <span style="font-weight:bold;"> ATT: </span><span
                    style="font-weight:bold;font-size:14px;color:red;">De acordo com a estatística fornecida ao ITSL você atingiu o limite de estudantes para a
                     10ª classe para o anolectivo ${ls.get('anolectivo')}</span>
                     <p style="text-align:justify;"><span style="font-weight:bold;font-size:14px;">Nº Estudantes permitidos na  10ª:</span>
                  <v-chip>${(this.$store.state.config_estudante_instituicao.length) ? this.$store.state.config_estudante_instituicao[0].quantidade : ''}</v-chip></p>
                     <p style="text-align:justify;"><span style="font-weight:bold;font-size:14px;">Nº Estudantes cadastrados:</span>
                  <v-chip>${(this.$store.state.config_estudante_instituicao.length) ? this.cadastrados[0].cadastrados : ''}</v-chip></p>`, 'warning')
        } else this.menuSelected = opcao
      } else {
        this.isEstudanteEmpty = this.isValid()
        if (!this.isEstudanteEmpty) {
          this.menuSelected = opcao
        }
      }
    },
    fecharTelaComponente() {
      this.isEstudanteEmpty = false;
      this.getHistoricoAluno(this.estudantePesquisa)
      this.menuSelected = 1;
    }

  }

}

</script>

<style scoped>
.containerPesquisarComponete {
  width: 30%;
  margin: 0 auto;
}

.rigth_container_components {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.operacoes_container {
  padding: 5px;
  margin: 0;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 15px;
}

.operacoes_button {
  background-color: #efefef;
  border: 1px solid #8795a2;
  color: #656565;
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  margin-right: 10px;
  font-family: Montserrat;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  cursor: pointer;
  flex: 0 0 auto;
  margin-bottom: 10px;
  border-radius: 8px;
  flex-direction: row-reverse;
  height: auto;
}

.botao_selected {
  background-color: #c4d5e1;
}
</style>